import { Card, List, ListItemButton, styled } from '@mui/material';

export const MapListWrap = styled(List)`
  height: calc(100vh - 300px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MapListItem = styled(ListItemButton)`
  padding: 20px 30px;
  &:hover,
  &:focus,
  &:active {
    background-color: #f5f7fe;
  }
`;

export const PanelList = styled(Card)`
  z-index: 10;
  position: fixed;
  border-radius: 0px;
  padding: 40px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.06);
`;
